<div bsModal #personnelSelectorTable="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="personnelSelectorTable" aria-hidden="true" [config]="{backdrop: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bold">
                {{ l('SelectPersonnels')}}
            </div>
            <div class="modal-body">
                <personnel-table-filter (onFiltersChange)="filtersChange($event)"></personnel-table-filter>
                <table class="table table-borderless table-md">
                    <thead>
                        <tr>
                            <th>{{ l("Name") }}</th>
                            <th>{{ l("Location") }}</th>
                            <th>{{ l("Company") }}</th>
                            <!-- <th>{{ l("Trade") }}</th> -->
                        </tr>
                    </thead>
                    <tbody >
                        <tr class="d-block coloured">
                            <td colspan="3">
                                <label class="label-color">{{ l("Recent") }}  </label>
                                <button [disabled]="saving" type="button" class="btn btn-link"
                                (click)="ClearRecent()">{{l("Clear")}}</button>
                            </td>
                        </tr>
                        <ng-container *ngFor="let person of this.filteredPersonnel">
                            <tr *ngIf="person.wasRecentlyAssigned && person.filterShow" (click)="selectPerson(person, !person.selected)">
                                <td >
                                    <div class="row" >
                                        <div class="col-sm-1">
                                            <i *ngIf="person.selected == true"
                                                class="fas fa-check-square main-color cb mr-2"
                                                ></i>
                                            <i *ngIf="person.selected == false"
                                                class="fas fa-square cb mr-2"></i>
                                        </div>
                                        <div class="col-sm-10">

                                            {{ person.staffDetails.contactDetails.firstName }}
                                            {{ person.staffDetails.contactDetails.lastName }}
                                            <ng-container *ngIf="person.company">(</ng-container> {{ person.company }}
                                            <ng-container *ngIf="person.company">)</ng-container><br />
                                            <span class="identity">{{ person.staffDetails.contactDetails.emailAddress
                                                }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {{ person.location }}
                                </td>
                                <td>
                                    {{ person.company }}
                                </td>
                                <!-- <td>
                                    {{ person.trade }}
                                </td> -->
                            </tr>
                        </ng-container>
                        <tr *ngIf="!checkFilteredPersonnelNull(this.filteredPersonnel)" class="d-block coloured">
                            <td colspan="3">
                                <label class="label-color">{{ l("All") }}  </label> </td>
                        </tr>
                        <tr *ngIf="checkFilteredPersonnelNull(this.filteredPersonnel)"><td colspan="3">{{ l('NoResultsFound') }}</td></tr>
                        <ng-container *ngFor="let person of this.filteredPersonnel">
                            <tr *ngIf="!person.wasRecentlyAssigned && person.filterShow" (click)="selectPerson(person, !person.selected)">
                                <td>
                                    <div class="row">
                                        <div class="col-sm-1">
                                            <i *ngIf="person.selected == true"
                                                class="fas fa-check-square main-color cb  mr-2"
                                                ></i>
                                            <i *ngIf="person.selected == false" class="fas fa-square cb  mr-2"
                                                ></i>
                                        </div>
                                        <div class="col-sm-10">

                                            {{ person.staffDetails.contactDetails.firstName }}
                                            {{ person.staffDetails.contactDetails.lastName }}
                                            <ng-container *ngIf="person.company">(</ng-container> {{ person.company }}
                                            <ng-container *ngIf="person.company">)</ng-container> <br />
                                            <span class="identity"> {{ person.staffDetails.contactDetails.emailAddress
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {{ person.location }}
                                </td>
                                <td>
                                    {{ person.company }}
                                </td>
                                <!-- <td>
                                    {{ person.trade }}
                                </td> -->
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button [disabled]="saving" type="button" class="btn btn-primary"
                    (click)="close()">{{l("Close")}}</button>
            </div>
        </div>
    </div>
</div>
<table class="table table-borderless rows-no-padding assign-personal-table">

    <tr *ngFor="let personnel of getSelectedPersonal(); let i = index" class="table-row">
            <td class="align-middle display-table-items-center">
                <i class="fas fa-check-square main-color margin-right-5"></i>

                {{ personnel.personnelDetails.firstName }}
                {{ personnel.personnelDetails.lastName }}
            </td>

            <td class="align-middle text-sm-right display-table-items-center">
                <input *ngIf="!isAllocationSheet()"
                [(ngModel)]="personnel.actualHours"
                (blur)="updateAllocatedPersonnelList($event)"
                class="form-control form-control-sm float-right"
                [disabled]="controlDisabled"
                onKeyPress="if((!this.value.includes('.') && this.value.length >= 4 && event.key !== '.') || (this.value.includes('.') && this.value.split('.')[1].length >= 4)) return false"
                style="max-width: 80px"
                step=".01"
                type="number" min="1" max="24" required/>
                <span *ngIf="isAllocationSheet()">
                    {{ personnel.actualHours }}
                </span>
                <div>hrs</div>
            </td>

            <td class="align-middle cell-btn-delete display-table-items-center">
                <button *ngIf="!isAllocationSheet()"
                class="btn btn-sm"
                [disabled]="controlDisabled"
                (click)="removeItem(personnel.personnelId)">
                <i class="fa fa-trash"
                data-toggle="popover"
                data-trigger="hover"
                data-html="true"
                [popover]="popTemplate"
                triggers="mouseenter:mouseleave"></i>

                <ng-template #popTemplate>
                    <div [innerHtml]="getPersonnelDeleteToolTip(personnel)"></div>
                </ng-template>
                </button>
            </td>
        </tr>

</table>
<button class="btn btn-default" *ngIf="!isAllocationSheet()" [disabled]="controlDisabled" (click)="show()">
    <i class="fas fa-plus"></i> {{ l("Add") }}
</button>
<div class="validation-msg" *ngIf="showError() && !anyResourceSelected">{{ l('MinResourceSelectionCriteria') }}</div>
